import { useCallback } from 'react';
import { useAuthStore } from '../stores/authStore';

/**
 * Custom hook for authentication state and actions
 * Provides a clean API for components to interact with auth state
 */
export const useAuth = () => {
  const store = useAuthStore();
  
  const signOut = useCallback(
    () => store.signOut(),
    []
  );
  
  const checkAuthStatus = useCallback(
    () => store.checkAuthStatus(),
    []
  );
  
  const initialize = useCallback(
    () => store.initialize(),
    []
  );
  
  const handleGoogleSignIn = useCallback(
    () => store.handleGoogleSignIn(),
    []
  );
  
  return {
    // State
    isAuthenticated: store.isAuthenticated,
    isLoading: store.isLoading,
    user: store.user,
    
    // Computed values
    isSignedIn: store.isAuthenticated && !!store.user,
    isSignedOut: !store.isAuthenticated && !store.isLoading,
    
    // Actions (stabilized)
    signOut,
    checkAuthStatus,
    initialize,
    handleGoogleSignIn,
  };
};
